import '../styles/also.scss';
import booking from "./components/booking";

(function (jQuery) {
    window.$ = jQuery.noConflict();
    $(() => {
        booking();
    });

})(jQuery);
